import React from "react";
// import {auth , provider}  from '../firebase.js';
import Box from "@mui/material/Box";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import Button from "@mui/material/Button";

const Login = () => {
  // Sign in with google
  const signin = () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const user = result.user;
        // ...
        console.log(user);
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // // The email of the user's account used.
        // const email = error.email;
        // // The AuthCredential type that was used.
        // const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
        console.error('Failed with error', errorCode, errorMessage)
      });
  };

  return (
    <Box sx={{ paddingTop : '2rem' }}>
      <center>
        <Button variant="outlined" onClick={signin}>Sign In with Google</Button>
      </center>
    </Box>
  );
};

export default Login;
